// app/javascript/project_approvals.js

export function initProjectApprovals() {
  const form = document.getElementById("approvalForm");
  const saveBtn = document.getElementById("saveApprovalBtn");

  if (!form || !saveBtn) return;

  saveBtn.onclick = function () {
    const projectId = form.dataset.projectId;
    const url = `/projects/${projectId}/approvals`;
    const method = "POST";

    const payload = {
      status: document.getElementById("approval_status").value,
      comment: document.getElementById("approval_comment").value
    };

    fetch(url, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: JSON.stringify({ project_approval: payload })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          toastr.success(data.message);

          // ✅ Update approvals table dynamically
          const tbody = document.querySelector("#approvals-table tbody");
          if (tbody && data.approval) {
            tbody.insertAdjacentHTML("beforeend", `
              <tr>
                <td>${data.approval.account}</td>
                <td>${data.approval.status}</td>
                <td>${data.approval.comment}</td>
                <td>${data.approval.created_at}</td>
              </tr>
            `);
          }

          form.reset();
          bootstrap.Offcanvas.getInstance(document.getElementById("eistApprovalFormModal")).hide();
        } else {
          toastr.error(data.message || "Failed to record approval");
        }
      })
      .catch(error => {
        console.error("Approval submission failed:", error);
        toastr.error("Network error while recording approval");
      });
  };
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProjectApprovals);
} else {
  initProjectApprovals();
}
